import React from 'react';
import getLanguage, {getAvailableFormLanguages, LanguageId} from '../../../models/utils/Languages';
import UIListBox from '../../../ui/form/UIListBox';

type Props = {
  className?: string
  selectedLanguage?: LanguageId
  setSelectedLanguage: (lang: LanguageId) => void
}
export default function LanguageSelector({selectedLanguage, setSelectedLanguage, className}: Props) {
  const availableLanguages = getAvailableFormLanguages();
  const options = availableLanguages
    .map((langId, index) => ({
      label: getLanguage(langId), value: langId, selected: index === 0, id: langId,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <>
      <UIListBox onChange={setSelectedLanguage} options={options} value={selectedLanguage}
        className={className}/>
    </>
  );
}
